/**
 * Product Gallery Badge Controller
 * Hides the industrial wash badge when video media is active
 */
class ProductGalleryBadgeController {
  constructor() {
    this.init();
  }

  init() {
    // Wait for DOM to be ready
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', () => this.setupEventListeners());
    } else {
      this.setupEventListeners();
    }
  }

  setupEventListeners() {
    // Find all product galleries
    const productGalleries = document.querySelectorAll('product-gallery');
    
    productGalleries.forEach(gallery => {
      // Find the badge within this gallery
      const badge = gallery.querySelector('.product-gallery__badge');
      
      if (badge) {
        // Listen for carousel changes
        gallery.addEventListener('carousel:change', (event) => {
          this.handleCarouselChange(event, badge);
        });
        
        // Also listen for carousel settle events
        gallery.addEventListener('carousel:settle', (event) => {
          this.handleCarouselChange(event, badge);
        });
        
        // Set initial state
        this.setInitialBadgeState(gallery, badge);
      }
    });
  }

  handleCarouselChange(event, badge) {
    const slide = event.detail?.slide;
    if (!slide) return;

    const mediaType = slide.getAttribute('data-media-type');
    
    // Hide badge for video types, show for others
    if (mediaType === 'video' || mediaType === 'external_video') {
      badge.style.display = 'none';
    } else {
      badge.style.display = '';
    }
  }

  setInitialBadgeState(gallery, badge) {
    // Find the currently active slide
    const carousel = gallery.querySelector('media-carousel');
    if (!carousel) return;

    const activeSlide = carousel.querySelector('.product-gallery__media[aria-current="true"]') || 
                       carousel.querySelector('.product-gallery__media:not([hidden])');
    
    if (activeSlide) {
      const mediaType = activeSlide.getAttribute('data-media-type');
      
      if (mediaType === 'video' || mediaType === 'external_video') {
        badge.style.display = 'none';
      } else {
        badge.style.display = '';
      }
    }
  }
}

// Initialize the controller
new ProductGalleryBadgeController();
